import { render } from "./CommentSidebar.vue?vue&type=template&id=cd9713ae&scoped=true"
import script from "./CommentSidebar.vue?vue&type=script&lang=js"
export * from "./CommentSidebar.vue?vue&type=script&lang=js"

import "./CommentSidebar.vue?vue&type=style&index=0&id=cd9713ae&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd9713ae"]])

export default __exports__